import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LlSecondaryButton from '@/components/LlSecondaryButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateAccountSummaryModal',
  emits: ['closeDialog'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "p-4" }, {
    title: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createTextVNode(" Account Summary ", -1)
    ]))]),
    append: _withCtx(() => [
      _createVNode(_component_v_icon, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeDialog')))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("mdi-close", -1)
        ]))]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, { class: "flex" }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "w-7/12 pr-4" }, [
            _createElementVNode("div", { class: "text-sm text-left text-gray-900" }, " Provide your clients with a summary of new changes to their account. "),
            _createElementVNode("div", { class: "py-2 text-sm text-left text-gray-900" }, " These are the definitions of each line item automatically generated in the account and retainer summaries your clients will receive in their invoice emails. "),
            _createElementVNode("div", { class: "py-2" }, [
              _createElementVNode("div", { class: "p-2 text-white mb-1 bg-legend-header" }, " Account Summary "),
              _createElementVNode("div", { class: "flex p-2 mb-1 bg-legend-row-light" }, [
                _createElementVNode("span", { class: "w-4/12" }, "Balance Forward"),
                _createElementVNode("span", { class: "w-8/12" }, "Existing account balance for client or matter")
              ]),
              _createElementVNode("div", { class: "flex p-2 mb-1 bg-legend-row-faint" }, [
                _createElementVNode("span", { class: "w-4/12" }, "New Charges"),
                _createElementVNode("span", { class: "w-8/12" }, "Invoice amount")
              ]),
              _createElementVNode("div", { class: "flex p-2 mb-1 bg-legend-row-light" }, [
                _createElementVNode("span", { class: "w-4/12" }, "Payments Received*"),
                _createElementVNode("span", { class: "w-8/12" }, "Any other actual payments recorded on the invoice")
              ]),
              _createElementVNode("div", { class: "flex p-2 mb-1 bg-legend-row-faint" }, [
                _createElementVNode("span", { class: "w-4/12" }, "Paid from Retainer*"),
                _createElementVNode("span", { class: "w-8/12" }, "Any actual payments recorded from the client's retainer")
              ]),
              _createElementVNode("div", { class: "flex mb-1 p-2 bg-legend-row-light" }, [
                _createElementVNode("span", { class: "w-4/12" }, "To Pay"),
                _createElementVNode("span", { class: "w-8/12" }, "The calculated amount owed to the firm")
              ]),
              _createElementVNode("div", { class: "p-2 flex text-white mb-1 bg-legend-header" }, [
                _createElementVNode("span", { class: "w-4/12" }, "Retainer Summary"),
                _createElementVNode("span", { class: "w-8/12" }, "Only populates if the client or matter has a trust account")
              ]),
              _createElementVNode("div", { class: "flex p-2 mb-1 bg-legend-row-faint" }, [
                _createElementVNode("span", { class: "w-4/12" }, "Starting Retainer Balance"),
                _createElementVNode("span", { class: "w-8/12" }, "Retainer balance before recording any payments")
              ]),
              _createElementVNode("div", { class: "flex p-2 mb-1 bg-legend-row-light" }, [
                _createElementVNode("span", { class: "w-4/12" }, "Ending Retainer Balance"),
                _createElementVNode("span", { class: "w-8/12" }, "Retainer balance after sending the invoice")
              ]),
              _createElementVNode("div", { class: "flex p-2 mb-1 bg-legend-row-faint" }, [
                _createElementVNode("span", { class: "w-4/12" }, "Retainer Minimum Balance*"),
                _createElementVNode("span", { class: "w-8/12" }, "The evergreen retainer amount")
              ])
            ]),
            _createElementVNode("div", { class: "py-4" }, " *These line items will only appear in the summary if there is a non-zero amount to show. ")
          ], -1),
          _createElementVNode("div", { class: "pl-4 w-5/12 pt-6" }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", { class: "py-4" }, [
                _createElementVNode("b", null, "Example preview:")
              ]),
              _createElementVNode("div", { class: "border-2 border-green-regular p-2" }, [
                _createElementVNode("div", { class: "p-2 text-base font-bold" }, [
                  _createElementVNode("span", null, "Account Summary")
                ]),
                _createElementVNode("div", { class: "flex justify-between px-2" }, [
                  _createElementVNode("span", null, "Balance Forward"),
                  _createElementVNode("span", null, "$100.00")
                ]),
                _createElementVNode("div", { class: "flex justify-between px-2" }, [
                  _createElementVNode("span", null, "New Charges"),
                  _createElementVNode("span", null, "$100.00")
                ]),
                _createElementVNode("div", { class: "flex justify-between px-2" }, [
                  _createElementVNode("span", null, "Payments Received"),
                  _createElementVNode("span", { class: "text-red-500" }, "-$60.00")
                ]),
                _createElementVNode("div", { class: "flex justify-between px-2" }, [
                  _createElementVNode("span", null, "Paid from Retainer"),
                  _createElementVNode("span", { class: "text-red-500" }, "-$10.00")
                ]),
                _createElementVNode("div", { class: "flex justify-between px-2 text-green-regular border-t-2 border-gray-700" }, [
                  _createElementVNode("span", null, "To Pay"),
                  _createElementVNode("span", null, "$130.00")
                ]),
                _createElementVNode("div", { class: "p-2 text-base font-bold" }, [
                  _createElementVNode("span", null, "Retainer Summary")
                ]),
                _createElementVNode("div", { class: "flex justify-between px-2 italic" }, [
                  _createElementVNode("span", null, "Starting Retainer Balance"),
                  _createElementVNode("span", null, "$10.00")
                ]),
                _createElementVNode("div", { class: "flex justify-between px-2 italic" }, [
                  _createElementVNode("span", null, "Ending Retainer Balance"),
                  _createElementVNode("span", null, "$0.00")
                ]),
                _createElementVNode("div", { class: "flex justify-between px-2 italic pb-2" }, [
                  _createElementVNode("span", null, "Retainer Minimum Balance"),
                  _createElementVNode("span", null, "$123.00")
                ])
              ])
            ])
          ], -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, { class: "flex justify-end mr-4 mb-4" }, {
        default: _withCtx(() => [
          _createVNode(LlSecondaryButton, {
            variant: "outlined",
            class: "px-4",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('closeDialog')), ["prevent"]))
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Close ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})